import type { ISupportedLanguagesAndLocale } from "app/components/campaigns/campaigns-wizard/CampaignsWizardConsts";
import type { ILocationObject } from "app/components/campaigns/queryBar-report/reports-pages-filters/CmapaignsIfraTypes";
import type { ICampaignsScrapingConfiguration } from "app/components/campaigns/shared/CampaignsConst";
import { getScarpingConfigsForCurrentDevice } from "app/components/campaigns/shared/CampaignsUtils";

const LANGUAGE_DESCRIPTION_SEPARATOR = " - ";
const getFormattedLocationDetails = (
    scrapingConfig: ICampaignsScrapingConfiguration,
    languagesList: ISupportedLanguagesAndLocale[],
): ILocationObject => {
    const language = languagesList?.find((lang) => lang.locale === scrapingConfig.locale);
    const locationWithShortLanguage = language?.description.includes(LANGUAGE_DESCRIPTION_SEPARATOR)
        ? language?.description.split(LANGUAGE_DESCRIPTION_SEPARATOR)[1]
        : language?.description;
    return {
        countryIconID: scrapingConfig.geoLocationCountry,
        id: `${scrapingConfig.geoLocation}_${language?.locale}`,
        text: `${scrapingConfig.geoLocation} (${locationWithShortLanguage})`,
    };
};

export const getAvailableLocations = (
    scrapingConfigurations: ICampaignsScrapingConfiguration[],
    device: string,
    languagesList: ISupportedLanguagesAndLocale[],
): ILocationObject[] => {
    const scarpingConfigsForCurrentDevice: ICampaignsScrapingConfiguration[] = getScarpingConfigsForCurrentDevice(
        scrapingConfigurations,
        device,
    );

    return scarpingConfigsForCurrentDevice?.map((scrapingConfig: ICampaignsScrapingConfiguration) => {
        return getFormattedLocationDetails(scrapingConfig, languagesList);
    });
};

export const getDevicesWithAvailabilityForSelectedCampaign = <T extends { id: string }>(
    devices: T[],
    scrapingConfigurations: ICampaignsScrapingConfiguration[],
): T[] => {
    return devices.map((device) => {
        const amountOfAvailableConfigs = getScarpingConfigsForCurrentDevice(scrapingConfigurations, device.id)?.length;
        return amountOfAvailableConfigs > 0 ? device : { ...device, disabled: true };
    });
};
